import type { IllustrationProps } from './types';
import {
  ILLUSTRATION_PALETTE,
  IllustrationSvg,
  SkyBackdrop,
  SlopeSurface,
  StruggleMark,
  TractorFigure,
} from './shared';

export default function TractorStruggleIllustration({
  className,
  width,
  height,
  primaryColor,
  accentColor,
}: IllustrationProps) {
  const accent = accentColor ?? ILLUSTRATION_PALETTE.struggle;

  return (
    <IllustrationSvg className={className} width={width} height={height} title="İş makinesi zorlanıyor">
      <SkyBackdrop accent={accent} />
      <SlopeSurface startY={48} endY={22} accent={accent} />
      <TractorFigure cx={42} cy={14} tilt={-18} primary={primaryColor} />
      <StruggleMark x={58} y={10} />
    </IllustrationSvg>
  );
}
